import { jsx as n } from "react/jsx-runtime";
import { getCSSValue as s } from "../../utils/get-css-value.js";
import l from "clsx";
import { forwardRef as o } from "react";
import '../../assets/divider.css';const x = "_divider_8cqnt_7", i = {
  divider: x,
  "divider--axis-x": "_divider--axis-x_8cqnt_14",
  "divider--axis-y": "_divider--axis-y_8cqnt_18",
  "divider--variant-default": "_divider--variant-default_8cqnt_22",
  "divider--variant-light": "_divider--variant-light_8cqnt_26",
  "divider--variant-dark": "_divider--variant-dark_8cqnt_30"
}, c = o(
  ({
    className: t = "",
    variant: d = "default",
    margin: r,
    axis: e = "x",
    style: a = {},
    ...v
  }, _) => /* @__PURE__ */ n(
    "hr",
    {
      ...v,
      className: l(
        {
          [i.divider]: !0,
          [i["divider--variant-default"]]: d === "default",
          [i["divider--variant-light"]]: d === "light",
          [i["divider--variant-dark"]]: d === "dark",
          [i["divider--axis-x"]]: e === "x",
          [i["divider--axis-y"]]: e === "y"
        },
        t
      ),
      ref: _,
      style: {
        "--margin": r ? s(r) : void 0,
        ...a
      }
    }
  )
);
c.displayName = "Divider";
export {
  c as Divider
};
